module.exports = __webpack_public_path__ + "static/img/item2-top.0626ee12.png";